// extracted by mini-css-extract-plugin
export default {"root":"wxafh","storeName":"NY4EK","logoWrapper":"F0ujX","logo":"wGhFb","testPrefix":"Cs_4c"};